import { NgxPaginateComponent } from './paginate.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [NgxPaginateComponent],
  declarations: [NgxPaginateComponent]
})
export class NgxPaginateModule { }
